(() => {
  const initialize = () => {
    document.querySelectorAll('[data-hm-purchase-shortcuts]').forEach(bar => {
      if (bar.dataset.ready) return;
      bar.dataset.ready = 'true';
      const container = document.getElementById('ProductInfo-' + bar.dataset.sectionId);
      if (!container) return;
      const fit = container.querySelector('.hm-fit-advice');
      const help = bar.querySelector('[data-hm-fit-link]');
      const choose = bar.querySelector('[data-hm-options-link]');
      if (!fit) { help.textContent = 'Product details'; }
      const move = (event, target) => {
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'auto', block: 'center' });
        const focusTarget = target.querySelector('select, input:not([type="hidden"]), button, a') || target;
        if (!focusTarget.hasAttribute('tabindex') && !focusTarget.matches('select,input,button,a')) focusTarget.setAttribute('tabindex','-1');
        focusTarget.focus({preventScroll:true});
      };
      help.addEventListener('click', event => move(event, fit || container));
      choose.addEventListener('click', event => move(event, container.querySelector('variant-selects') || container.querySelector('product-form') || container));
      const buy = container.querySelector('product-form');
      if (buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(entries => { bar.hidden = entries[0].isIntersecting; }, {threshold:0}).observe(buy);
      } else { bar.hidden = false; }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
